import React, { useEffect, useState } from 'react';
import { withGoogleMap, withScriptjs, GoogleMap, Polyline, Marker } from 'react-google-maps';
import { io } from 'socket.io-client';
import { every, toInteger } from 'lodash';
import polyline from '@mapbox/polyline';
import axios from 'axios';
import { LockClock } from '@mui/icons-material';
import { Alert, Box, Container } from '@mui/material';
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next";


const Map = () => {
  const [progress, setProgress] = useState([]);
  const [location, setLocation] = useState([]);
  const [lineCoordinates, setlineCoordinates] = useState([]);
  const [directions, setDirections] = useState([]);
  const [alerting, setAlerting] = useState(false);
  const [la, setLa] = useState(0);
  const [ln, setLn] = useState(0);
  const [ready, setReady] = useState(false);
  const { t } = useTranslation();

  const { id } = useParams()


  useEffect(() => {
    const fetchData = async () => {
      const mashawiritoken = localStorage.getItem('mashawiritoken');
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}get_direction/${toInteger(id)}`, {
          headers: {
            Authorization: `Bearer ${mashawiritoken}`,
          },
        })
        setDirections(response.data.data);
        response.data.data.forEach(function (direction) {
          var decodedCoordinates = polyline.decode(direction.poly_line);
          var lineCoordinates = decodedCoordinates.map(function (coordinate) {
            setlineCoordinates((lineCoordinates) => [...lineCoordinates, { lat: coordinate[0], lng: coordinate[1] }]);
            return { lat: coordinate[0], lng: coordinate[1] };
          });
        }
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();

    var socket = io('https://mashawiri.com:3098');
    socket.emit('join_room', { trip_id: toInteger(id) });
 
    socket.on('start_trip', (data) => {
      socket.on('start_trip', (data) => {
        const newLocation = { lat: parseFloat(data.lat), lng: parseFloat(data.lng) };
          setLocation((prevLocation) => [...prevLocation, newLocation]);
        setLa(parseFloat(data.lat));
        setLn(parseFloat(data.lng));
        setReady(true)
      });
      setLocation((prevLocation) => [...prevLocation, { lat: data.lat, lng: data.lng }]);
      setLa(parseFloat(data.lat));
      setLn(parseFloat(data.lng));
      setReady(true)
    });
   
  }, []);


  useEffect(() => {
    var socket = io('https://mashawiri.com:3098');
    socket.on('leave_trip', (data) => {
      const mashawiritoken = localStorage.getItem('mashawiritoken');
    try {
      axios.post(
        `${process.env.REACT_APP_API_URL}path_of_car/${data[0].id}`,
        {
          'new_path_trip': data,
        }
      );
    } catch (error) {
      console.error(error);
    }
      if(data[0].id === toInteger(id)){
      setAlerting(true)
        }
    });
  }, []);

  
  return (
    <>
        {alerting &&
        <Box>
    <Alert severity="error"
    sx={{width:'79.5%',fontSize:'20px',fontWeight:'bold',backgroundColor:'#FE4138',position:'absolute',
    color:'white',top:'95px'}} >{t('Trip Ended')}</Alert>
    </Box>
    }
    {!alerting && ready &&
    <GoogleMap defaultZoom={19} defaultCenter={{ lat : la , lng : ln }}>
      {progress && (
        <>
          <Polyline path={lineCoordinates} options={{ strokeColor: '#006CE6',strokeWeight:'4' }} />
          {/* <Marker path={startLatLng} />
          <Marker path={endLatLng} /> */}

          <Polyline path={location} options={{ strokeColor: '#FF0000' }} />
          <Marker position={location[location.length - 1]} />  
        </>
      )}
    </GoogleMap>}
    </>
  );
};

const MapComponent = withScriptjs(withGoogleMap(Map));

export default () => (
  <MapComponent
    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyC29UPPPbYU6EsOx25Y_mohvE4ZNut4Yx8"
    loadingElement={<div style={{ height: '100%' }} />}
    containerElement={<div style={{ height: '700px', width: '100%' }} />}
    mapElement={<div style={{ height: '100%' }} />}
  />
);
